import _defineProperty from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _EMBED_OPTIONS;
import { PLAYER_TYPES } from "./constants";

/**
 * Wistia embed options
 * https://wistia.com/support/developers/embed-options#options
 */
export var EMBED_OPTIONS = (_EMBED_OPTIONS = {}, _defineProperty(_EMBED_OPTIONS, PLAYER_TYPES.DEFAULT_FROM_WISTIA, {
  videoFoam: true
}), _defineProperty(_EMBED_OPTIONS, PLAYER_TYPES.VIDEO_RESPONSIVE, {
  autoPlay: true,
  controlsVisibleOnLoad: false,
  fullscreenButton: false,
  muted: true,
  playbar: true,
  playButton: true,
  settingsControl: false,
  silentAutoPlay: true,
  videoFoam: true,
  volumeControl: true
}), _defineProperty(_EMBED_OPTIONS, PLAYER_TYPES.VIDEO_BACKGROUND, {
  autoPlay: true,
  controlsVisibleOnLoad: false,
  endVideoBehavior: 'loop',
  fitStrategy: 'cover',
  fullscreenButton: false,
  muted: true,
  playbar: false,
  playButton: false,
  settingsControl: false,
  silentAutoPlay: false,
  videoFoam: false,
  volumeControl: false
}), _EMBED_OPTIONS);